<template>
  <section class="login-section d-flex align-items-center justify-content-center">
    <div class="login-card p-5 rounded-3 shadow-lg">
      
      <!-- Logo -->
      <div class="logo-container text-center mb-4 fade-in-logo">
        <img src="@/assets/images/logo-gym-removebg-preview.png" alt="Victoria Gym Logo" class="login-logo">
      </div>

      <!-- Título -->
      <h2 class="text-center mb-4 gradient-text">Iniciar Sesión</h2>

      <form @submit.prevent="handleLogin">
        <!-- Correo electrónico -->
        <div class="mb-4">
          <label for="email" class="form-label">
            <i class="bi bi-envelope me-2"></i>Correo electrónico
          </label>
          <input type="email" v-model="email" class="form-control animated-input" id="email" placeholder="ejemplo@correo.com" required>
        </div>

        <!-- Contraseña con ojo dentro del input -->
        <div class="mb-4 position-relative">
          <label for="password" class="form-label">
            <i class="bi bi-lock me-2"></i>Contraseña
          </label>
          <div class="input-with-icon">
            <input 
              :type="showPassword ? 'text' : 'password'" 
              v-model="password" 
              class="form-control animated-input password-input" 
              id="password" 
              placeholder="••••••••" 
              required
            >
            <span class="toggle-password" @click="togglePassword">
              <i :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </span>
          </div>
        </div>

        <!-- Botón -->
        <button type="submit" class="btn btn-gradient w-100 fw-bold mt-3">
          Iniciar Sesión
        </button>

        <!-- Recordar y olvidar -->
        <div class="d-flex justify-content-between mt-3 small text-muted">
          <div>
            <input type="checkbox" id="remember" v-model="remember">
            <label for="remember">Recordarme</label>
          </div>
          <RouterLink to="/recuperar" class="text-warning">¿Olvidaste tu contraseña?</RouterLink>
        </div>
      </form>

      <!-- Registro -->
      <p class="text-center mt-4 small">
        ¿No tienes cuenta? 
        <RouterLink to="/registro" class="text-warning fw-bold">Regístrate aquí</RouterLink>
      </p>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';

const email = ref('');
const password = ref('');
const remember = ref(false);
const showPassword = ref(false);

function togglePassword() {
  showPassword.value = !showPassword.value;
}

function handleLogin() {
  alert(`Email: ${email.value}\nPassword: ${password.value}\nRecordarme: ${remember.value}`);
}
</script>

<style scoped>
.login-section {
  min-height: 100vh;
  background: url('@/assets/images/carruzel/gym3.webp') center/cover no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  backdrop-filter: blur(2px);
}

.login-card {
  background-color: rgba(255, 255, 255, 0.95);
  max-width: 400px;
  width: 100%;
  text-align: left;
  animation: fadeIn 0.8s ease forwards;
  position: relative;
  box-shadow: 0 15px 30px rgba(0,0,0,0.25);
  border-radius: 1rem;
}

/* Logo animado */
.login-logo {
  width: 120px;
  transition: transform 0.5s ease, filter 0.5s ease;
  animation: floatLogo 3s ease-in-out infinite;
}
@keyframes floatLogo {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

/* Título con gradiente animado */
.gradient-text {
  background: linear-gradient(90deg, #F97316, #FBBF24, #F97316);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 3s infinite linear;
}

/* Inputs */
.animated-input {
  border-radius: 0.6rem;
  border: 1px solid #ccc;
  transition: all 0.3s ease;
  width: 100%;
  padding: 0.625rem 2.5rem 0.625rem 0.75rem; /* espacio para el icono */
}
.animated-input:focus {
  border-color: #F97316;
  box-shadow: 0 0 12px rgba(249,115,22,0.3);
  transform: scale(1.02);
}

/* Ojo dentro del input */
.input-with-icon {
  position: relative;
  width: 100%;
}
.toggle-password {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 1.25rem;
  color: #888;
  transition: color 0.3s, transform 0.2s;
  z-index: 2;
}
.toggle-password:hover {
  color: #F97316;
  transform: translateY(-50%) scale(1.2);
}

/* Botón con gradiente */
.btn-gradient {
  background: linear-gradient(90deg, #F97316, #FBBF24);
  border: none;
  color: #fff;
  font-weight: 600;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.btn-gradient:hover {
  transform: scale(1.05);
  box-shadow: 0 0 15px rgba(249,115,22,0.6);
}

/* Animaciones */
@keyframes fadeIn { from { opacity:0; transform: translateY(20px); } to { opacity:1; transform: translateY(0); } }
@keyframes gradientMove { 0%{background-position:0%} 100%{background-position:200%} }

/* Responsive */
@media (max-width: 576px) {
  .login-card { padding: 2rem 1.5rem; }
  .login-logo { width: 100px; }
}
</style>
